<template>
  <dialog-scroll-lock width="300" :value="true" @input="$emit('close', staged)">
    <v-card>
      <v-btn class="ma-3" style="right: 0;" absolute icon @click="$emit('close', staged)">
        <v-icon v-html="mdiClose" />
      </v-btn>
      <v-card-title>Select color</v-card-title>
      <template v-if="presets?.length">
        <v-divider />
        <div style="padding: 6px;">
          <v-btn
            v-for="c in presets" :key="c"
            v-blur fab x-small class="ma-2"
            v-bind:style="{
              'background': c,
              'border': staged == c ? '1px solid rgba(0, 0, 0, 0.12)' : null,
              'box-shadow': staged == c ? `0 0 8px 4px ${c} !important` : null
            }"
            @click="staged = c; $emit('input', c);"
          />
        </div>
      </template>
      <v-divider />
      <v-color-picker mode="rgba" v-model="staged" @input="$emit('input', staged)" />
    </v-card>
  </dialog-scroll-lock>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'color-prompt',

  components: {
  },

  props: [ 'value', 'presets' ],

  data() {
    return {
      staged: '#FFFFFF'
    };
  },

  created() {
    Object.assign(this, { mdiClose });
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        // There is a bug with the v-color-picker where if it gets a value like '#xxx' it automatically expands it to
        // a representation like '#xxxxxxFF', which results in the color picker showing an alpha channel
        v = v || '#FFFFFF';
        this.staged = (/^#...$/.test(v) ? '#' + v[1] + v[1] + v[2] + v[2] + v[3] + v[3] : v).toUpperCase();
      }
    }
  }
}
</script>
